import React, { useContext } from "react";
import ParameterContext from "../context/parameter/parameterContext";
import ReactPaginate from "react-paginate";
import { IoCaretBackSharp, IoCaretForwardSharp } from "react-icons/io5";
import { GoPlus } from "react-icons/go";
import authContext from "../context/auth/authContext";
import { useWindowSize } from "react-use";
const Pagination = ({ pages }) => {
  const { activePortfolio, setActivePortfolioPage } =
    useContext(ParameterContext);
  const { userData } = useContext(authContext);
  const handlePageClick = (e) => {
    setActivePortfolioPage(e.selected + 1);
  };
  const { width} = useWindowSize();
  return (
    <ReactPaginate
      previousLabel={
        <span>
          <IoCaretBackSharp />
        </span>
      }
      nextLabel={
        <span>
          <IoCaretForwardSharp />
        </span>
      }
      breakLabel={". . ."}
      pageCount={userData.VirtualPortfolio.length + 1}
      marginPagesDisplayed={width < 600 ? 0 : 1}
      pageRangeDisplayed={width < 600 ? 0 : 1}
      onPageChange={handlePageClick}
      containerClassName="Pagination__container"
      activeClassName="Pagination__active"
      pageClassName="Pagination__list"
      previousClassName="Pagination__marginpages"
      nextClassName="Pagination__marginpages"
      breakClassName="Pagination__breakpages"
      pageLinkClassName="Pagination__refpages"
      previousLinkClassName="Pagination__refpages"
      nextLinkClassName="Pagination__refpages"
      breakLinkClassName="Pagination__refpages"
      activeLinkClassName="Pagination__active"
      disabledClassName="Pagination__disabled"
      forcePage={activePortfolio - 1}
      pageLabelBuilder={(page) =>
        page === userData.VirtualPortfolio.length + 1 ? (
          <span>
            <GoPlus />
          </span>
        ) : (
          page
        )
      }
    />
  );
};

export default Pagination;
